<template>
  <div class="user-distribution-bd">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item v-if="funcView.user_add_group_device|| !!orgId">
          <el-button type="primary" icon="el-icon-plus" :disabled="!userId" @click="openBindGroup">{{ $t('base_user_distribution.jrzzbmxm') }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.user_unbind_group_device || !!orgId">
          <el-button type="primary" icon="el-icon-minus" :disabled="!tableSelect.length" @click="onUnbindGroup(tableSelect, true)">{{ $t('base_user_distribution.tczzbmxm') }}</el-button>
        </el-form-item>
        <!-- 配置表格列 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_user_distribution.zzmcbh')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table :index="true" type="checkbox" v-model="tableSelect" tableCode="user_distribution" :data="tableList" @column="setColumn" @filter="filterChange" @sort="sortChange">
        <template slot="action" slot-scope="scope">
          <el-button v-if="funcView.user_unbind_group_device || !!orgId" type="text" size="mini" @click="onUnbindGroup([scope.row])">
            {{ $t('base_user_distribution.tui_chu') }}
            </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <organ-group-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSuccess" :orgId="orgId"></organ-group-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import organGroupDialog from '@/pages/base/components/organGroupDialog';

export default {
  mixins: [resetFormSearchMixins],
  components: { organGroupDialog },
  props: {
    userId: {
      type: [String, Number, Boolean],
      default: '',
    },
    orgId: [String, Number]
  },
  data() {
    return {
      formSearch: {
        orgId: '',
        userId: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      tableSelect: [],
      dialogVisible: false,
      dialogModel: {},
    };
  },
  watch: {
    userId: function () {
      this.resetFormSearch = JSON.stringify(this.formSearch);
      this.getOrganGroupPage();
    },
  },
  mounted: function () {
    this.getFuncView('/company/user');
    this.getOrganGroupPage();
  },
  methods: {
    onSuccess() {
      this.$emit('success');
      this.getOrganGroupPage();
    },
    // 获取关联组织/分组
    getOrganGroupPage: function () {
      if (!this.userId) {
        this.tableList = [];
        this.totalRows = 0;
        return;
      }
      this.formSearch.userId = this.userId;
      this.$getJSON(apis.OrganAutoBindByUser, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getOrganGroupPage();
    },
    // 取消组织/部门/分组
    onUnbindGroup: function (rows, checkbox) {
      const tip = checkbox ? this.$t('base_user_distribution.nqdyjxzdyhcxzdzzbmxm') : this.$t('base_user_distribution.nqdyjxzdyhcxzdzzbmxm');
      this.$showConfirm(tip)
        .then(() => {
          this.cancelDevice(rows);
        })
        .catch(() => {});
    },
    // 取消关联组织、分组
    cancelDevice: function (rows) {
      const bindAutomaticIds = rows.map(t => ({
        bizId: t.toBizId,
        bizType: t.toBizType,
      }));
      const params = {
        userId: this.userId,
        orgDepartments: bindAutomaticIds
      };
      this.$postJSON(apis.OrganUnbindbyUser, params).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.getOrganGroupPage();
      });
    },
    // 关联组织/部门/分组
    openBindGroup: function () {
      this.dialogModel.title = this.$t('base_user_distribution.jrzzbmxm');
      this.dialogModel.userId = this.userId;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss"></style>
